// Angular Imports
import { NgModule } from '@angular/core';
import { FlyoutSearchModule } from './flyout-search/flyout-search.module';
// import { LoginPickerModule } from './login-picker/login-picker.module';

// This Module's Components

@NgModule({
  imports: [
    FlyoutSearchModule
    // LoginPickerModule
  ],
  declarations: [],
  exports: [
    FlyoutSearchModule
    // LoginPickerModule
  ]
})
export class FlyoutModule {}
